import { SVGProps, memo } from "react"

const Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 36 36"
    height={35}
    style={{
      marginRight: ".75em",
    }}
    {...props}
  >
    <path
      fill="#EEE"
      d="M36 27a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V9a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v18z"
    />
    <path
      fill="#C60C30"
      d="M21.441 13.085a6 6 0 0 0-8.356 1.474A3.001 3.001 0 0 0 18 18a3 3 0 0 1 4.915 3.442 6 6 0 0 0-1.474-8.357z"
    />
    <path
      fill="#003478"
      d="M22.178 17.264A3 3 0 0 0 18 18a3.001 3.001 0 0 1-4.915-3.442 6 6 0 1 0 9.829 6.882 2.997 2.997 0 0 0-.736-4.176z"
    />
    <path
      d="m24.334 25.572 1.928-2.298.766.643-1.928 2.298zm2.57-3.063 1.928-2.297.766.643-1.928 2.297zm-1.038 4.351 1.928-2.297.766.643-1.928 2.297zm2.572-3.066 1.93-2.297.766.644-1.93 2.296zm-1.041 4.352 1.93-2.297.765.643-1.929 2.297zm2.571-3.065 1.927-2.3.767.643-1.927 2.3zm.004-14.162.766-.643 1.93 2.299-.767.643zM27.4 7.853l.766-.643 1.928 2.299-.767.642zm-1.533 1.288.766-.643 4.5 5.362-.766.643zm-1.532 1.284.767-.643 1.927 2.298-.766.642zm2.57 3.065.766-.643 1.93 2.297-.765.643zM6.4 20.854l.766-.643 4.499 5.363-.767.643zM4.87 22.14l.765-.642 1.929 2.298-.767.643zm2.567 3.066.766-.643 1.93 2.297-.766.643zm-4.101-1.781.766-.643 4.5 5.362-.767.643zm-.001-10.852 4.498-5.362.767.642-4.5 5.363zm1.532 1.287 4.5-5.363.766.643-4.5 5.362zM6.4 15.145l4.5-5.363.766.643-4.5 5.363z"
      fill="#292F33"
    />
  </svg>
)

const FlagKR = memo(Icon)
export default FlagKR
